export default "__VITE_ASSET__D$bfJBi2__"